import React, { useState, useEffect } from 'react';

export function useDebounceState<T>(initialValue: T, delay: number = 300): [T, T, React.Dispatch<React.SetStateAction<T>>] {
    const [value, setValue] = useState<T>(initialValue);
    const [debouncedValue, setDebouncedValue] = useState<T>(initialValue);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);

        return () => {
            clearTimeout(handler);
        };
    }, [value, delay]);

    return [value, debouncedValue, setValue];
}

export default useDebounceState;
